export const iconFontAwesomeCharitySeedling = (
	<i className="fa-solid fa-seedling"></i>
);
